export const FETCH_MAP_DETAILS = "FETCH_MAP_DETAILS";
export const RESET_MAP_DETAILS = "RESET_MAP_DETAILS";
export const FETCH_MAP_DETAILS_ON_ATTRACTION = "FETCH_MAP_DETAILS_ON_ATTRACTION";